var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 24,
    viewBox: "0 0 62 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_742_300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4118 0H0V24H61.4118V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_742_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7705 17.8992V2.11768H46.9427V17.8992H43.7705Z",
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80052 22.587H0V6.80554H6.52705C9.69925 6.80554 11.5476 8.53438 11.5476 11.2386C11.5476 12.9892 10.3605 14.1204 9.53887 14.4971C10.5196 14.9401 11.775 15.9373 11.775 18.0441C11.775 20.991 9.69925 22.587 6.80052 22.587ZM6.27597 9.55452H3.17216V13.1896H6.27597C7.62219 13.1896 8.37543 12.458 8.37543 11.3714C8.37543 10.2861 7.62219 9.55452 6.27597 9.55452ZM6.48107 15.9603H3.17216V19.8393H6.48107C7.91922 19.8393 8.60287 18.9532 8.60287 17.8883C8.60287 16.8247 7.91795 15.9603 6.48107 15.9603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4506 16.1148V22.587H18.3008V16.1148L13.417 6.80554H16.8626L19.8981 13.1666L22.8875 6.80554H26.3332L21.4506 16.1148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3264 22.587H28.5259V6.80554H35.053C38.2251 6.80554 40.0735 8.53438 40.0735 11.2386C40.0735 12.9892 38.8864 14.1204 38.0648 14.4971C39.0455 14.9401 40.301 15.9373 40.301 18.0441C40.301 20.991 38.2251 22.587 35.3264 22.587ZM34.8019 9.55452H31.698V13.1896H34.8019C36.1481 13.1896 36.9013 12.458 36.9013 11.3714C36.9013 10.2861 36.1481 9.55452 34.8019 9.55452ZM35.0069 15.9603H31.698V19.8393H35.0069C36.4451 19.8393 37.1287 18.9532 37.1287 17.8883C37.1287 16.8247 36.4451 15.9603 35.0069 15.9603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1666 9.55452V22.5882H53.9944V9.55452H49.7495V6.80554H61.4115V9.55452H57.1666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.66b3e4214a9aeba70c7d005d62259b46.svg";
export { ForwardRef as ReactComponent };